<frontend-pull-refresh></frontend-pull-refresh>

<div class="px-3 pb-3" *ngIf="user && location">
  <div class="table-wrapper">
    <table class="table tr-table table-bottom-spacer">
      <thead>
      <tr>
        <th>Name</th>
        <th class="text-center">Users</th>
        <th class="text-center">Waitlisted Parties</th>
        <th class="text-center">Estimated Wait</th>
        <th class="text-center">Subscription plan</th>
        <th class="text-center">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <tablesready-location-name-column
            [location]="location"
            [email]="user.email"
          ></tablesready-location-name-column>
        </td>
        <td class="text-center">
          <a
            class="td-link"
            *ngIf="location.enabled"
            [innerText]="usersCount"
            (click)="navigateToLocationPage(location._id, '/settings/location/users')"
          ></a>
        </td>
        <td class="text-center" [innerText]="getWaitlistedPartiesByLocation(location._id)"></td>
        <td class="text-center" [innerText]="location.default_quoted_time"></td>
        <td class="text-center">
          <tablesready-sms-usage
            [subscriptionType]="user.account.subscriptionType"
            [pricePlan]="currentPricePlan"
            [usage]="location.usage"
            [timezone]="location.timezone"
          ></tablesready-sms-usage>
        </td>
        <td>
          <div class="d-flex flex-row justify-content-center align-items-center">
            <button class="btn btn-icon btn-info-outline" (click)="editLocation()">
              <tr-icon [icon]="icon.edit" [color]="color.blue"></tr-icon>
            </button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
